import type { IEpochGraphQlService, IEpochGraphQlTransport } from "./interfaces"
import type { EpochApiData } from "./types"

export class EpochGraphQlTransport implements IEpochGraphQlTransport {
  constructor(private graphQlService: IEpochGraphQlService) {}

  /**
   * Load current epoch from GraphQL
   * Pure data loading - no state, no caching, no side effects
   */
  async loadCurrentEpoch(): Promise<EpochApiData | null> {
    return await this.graphQlService.getCurrentEpoch()
  }

  /**
   * Load epochs from GraphQL with minimum epoch number filter
   * Pure data loading - no state, no caching, no side effects
   */
  async loadEpochs(minEpochNumber: number): Promise<EpochApiData[]> {
    return await this.graphQlService.getEpochs(minEpochNumber)
  }
}
